export const validator = value => Boolean(value)
